import {Component, Input, OnInit} from '@angular/core';
import {WerteSammlung} from '../../../models/werte-sammlung.model';
import {ChartDataSets, ChartOptions, ChartType} from 'chart.js';
import {Label} from 'ng2-charts';
import {Monatswert} from '../../../models/monatswert.model';
import {DatePipe} from '@angular/common';
import {WerteListe} from '../../../models/werte-liste.model';
import {TypeConfig} from '../../../models/overviewTypeConfig.model';

@Component({
  selector: 'mp-detail-verbrauch-graph',
  templateUrl: './detail-verbrauch-graph.component.html',
  styleUrls: ['./detail-verbrauch-graph.component.css']
})
export class DetailVerbrauchGraphComponent implements OnInit {

  @Input() data: WerteSammlung;
  @Input() typeConfig: TypeConfig;

  valueMap: Map<number, ChartDataSets> = new Map();

  barChartData: ChartDataSets[] = [];
  labels: Label[] = [];
  options: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          callback: (value, index, values) => value + ' ' + this.data.einheit
        }
      }],
      xAxes: [{
        ticks: {
          autoSkip: false,
          maxRotation: 90,
          minRotation: 90,
        }
      }]
    },
    plugins: {
      legend: {
        labels: {
          usePointStyle: true,
        },
        position: 'top'
      },
    },
    legend: {
      labels: {
        usePointStyle: true,
      },
      position: 'top'
    },
    tooltips: {
      callbacks: {
        title: (items, data) => this.typeConfig.name + ' (' + data.datasets[items[0].datasetIndex].label + ')',
        label: (items, data) => items.label + ': ' + parseFloat(items.value).toLocaleString('de-DE', { minimumFractionDigits: 3, maximumFractionDigits: 3 } ) + ' ' + this.data.einheit
      },
      backgroundColor: '#FFF',
      titleFontSize: 15,
      titleFontColor: 'rgb(8,74,147)',
      bodyFontColor: '#000',
      bodyFontSize: 13,
      displayColors: false,
      borderColor: 'rgba(8,74,147,0.42)',
      borderWidth: 1,
    }
  };
  barChartType: ChartType = 'bar';

  constructor(private pipe: DatePipe) {
  }

  ngOnInit(): void {
    this.initializeChart();
  }

  private initializeChart(): void {
    this.addMonthLabelsToChart();
    this.setValueMapWithNameAndColor(1, 'Aktuell', this.data.aktuell);
    this.setValueMapWithNameAndColor(2, 'Vorjahr', this.data.vergleich);
    this.setValueMapWithNameAndColor(3, 'Durchschnitt Liegenschaft', this.data.durchschnittLiegenschaft);
    this.barChartData = [...this.valueMap.values()];
  }

  private setValueMapWithNameAndColor(index: number, valueTypeName: string, values: WerteListe): Map<number, ChartDataSets> {
    return this.valueMap.set(index, {
      data: this.transformValuesToBarChartData(values),
      label: valueTypeName,
      fill: false,
      borderColor: DetailVerbrauchGraphComponent.getColorByIndex(index),
      backgroundColor: DetailVerbrauchGraphComponent.getColorByIndex(index),
      hoverBackgroundColor: DetailVerbrauchGraphComponent.getColorByIndex(index),
    });
  }

  private static getColorByIndex(index: number): string {
    if (index === 1) {
      return 'rgb(8,74,147)';
    }
    if (index === 2) {
      return 'rgb(242,148,0)';
    } else {
      return 'rgba(8,74,147,0.42)';
    }
  }

  transformValuesToBarChartData(valueType: WerteListe): number[] {
    return this.sortedMonatswerte(valueType.monate).map(value => value.wert);
  }

  private addMonthLabelsToChart(): void {
    this.labels = this.sortedMonatswerte(this.data.aktuell.monate).map((e: Monatswert) => {
      return this.pipe.transform(e.datum, 'MMM yyyy', undefined, 'de');
    });
  }

  private getTime(date: Date): number {
    return date != null ? new Date(date).getTime() : 0;
  }

  private sortedMonatswerte(monate: Monatswert[]): Monatswert[] {
    const monateSorted = Object.assign([], monate);
    monateSorted.sort((a: Monatswert, b: Monatswert) => {
      return this.getTime(a.datum) - this.getTime(b.datum);
    });
    return monateSorted;
  }
}
